module.exports = __webpack_public_path__ + "static/media/peopleGroup7.613bb0ec.jpg";